<div class="visao-geral-responder" ngxUiLoaderBlurred [loaderId]="'loader-principal'">
    @if (!menor1024) {
        <app-responder-maior1024></app-responder-maior1024>
    } @else {
        <app-responder-menor1024></app-responder-menor1024>
    }
</div>
<ngx-ui-loader [loaderId]="'loader-principal'"></ngx-ui-loader>
